"use strict";

var _toConsumableArray = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeMatcher = exports.treeTypeParser = exports.listTypeParser = exports.removeTypeParser = exports.hasTypeParser = exports.addTypeParser = exports.type = void 0;

var _logger = _interopRequireDefault(require("../../logger"));

var _dataType = require("./dataType");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var types = {};
var dataTypes = {};
var unregExts = {};

var parseNativeTypes = function parseNativeTypes(input, dataType) {
  switch (dataType) {
    case 'Array':
      if (input.length === 0 || input.every(function (entry) {
        return type(entry) === '@csl/object';
      })) {
        return '@csl/list+object';
      } else {
        return '@else/list+object';
      }

    case 'SimpleObject':
    case 'ComplexObject':
      return '@csl/object';

    default:
      return '@invalid';
  }
};

var matchType = function matchType() {
  var typeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var data = arguments.length > 1 ? arguments[1] : undefined;

  var _iterator = _createForOfIteratorHelper(typeList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _type = _step.value;

      if (types[_type].predicate(data)) {
        return matchType(types[_type].extensions, data) || _type;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

var type = function type(input) {
  var dataType = (0, _dataType.dataTypeOf)(input);

  if (dataType === 'Array' && input.length === 0) {
    return parseNativeTypes(input, dataType);
  }

  var match = matchType(dataTypes[dataType], input);
  return match || parseNativeTypes(input, dataType);
};

exports.type = type;

var addTypeParser = function addTypeParser(format, _ref) {
  var dataType = _ref.dataType,
      predicate = _ref.predicate,
      extend = _ref["extends"];
  var extensions = [];

  if (format in unregExts) {
    extensions = unregExts[format];
    delete unregExts[format];

    _logger["default"].debug('[core]', "Subclasses \"".concat(extensions, "\" finally registered to parent type \"").concat(format, "\""));
  }

  var object = {
    predicate: predicate,
    extensions: extensions
  };
  types[format] = object;

  if (extend) {
    var parentTypeParser = types[extend];

    if (parentTypeParser) {
      parentTypeParser.extensions.push(format);
    } else {
      if (!unregExts[extend]) {
        unregExts[extend] = [];
      }

      unregExts[extend].push(format);

      _logger["default"].debug('[core]', "Subclass \"".concat(format, "\" is waiting on parent type \"").concat(extend, "\""));
    }
  } else {
    var typeList = dataTypes[dataType] || (dataTypes[dataType] = []);
    typeList.push(format);
  }
};

exports.addTypeParser = addTypeParser;

var hasTypeParser = function hasTypeParser(type) {
  return Object.prototype.hasOwnProperty.call(types, type);
};

exports.hasTypeParser = hasTypeParser;

var removeTypeParser = function removeTypeParser(type) {
  delete types[type];
  var typeLists = [].concat(_toConsumableArray(Object.keys(dataTypes).map(function (key) {
    return dataTypes[key];
  })), _toConsumableArray(Object.keys(types).map(function (type) {
    return types[type].extensions;
  }).filter(function (list) {
    return list.length > 0;
  })));
  typeLists.forEach(function (typeList) {
    var index = typeList.indexOf(type);

    if (index > -1) {
      typeList.splice(index, 1);
    }
  });
};

exports.removeTypeParser = removeTypeParser;

var listTypeParser = function listTypeParser() {
  return Object.keys(types);
};

exports.listTypeParser = listTypeParser;

var treeTypeParser = function treeTypeParser() {
  var attachNode = function attachNode(name) {
    return {
      name: name,
      children: types[name].extensions.map(attachNode)
    };
  };

  return {
    name: 'Type tree',
    children: Object.keys(dataTypes).map(function (name) {
      return {
        name: name,
        children: dataTypes[name].map(attachNode)
      };
    })
  };
};

exports.treeTypeParser = treeTypeParser;
var typeMatcher = /^(?:@(.+?))(?:\/(?:(.+?)\+)?(?:(.+)))?$/;
exports.typeMatcher = typeMatcher;